import "./style.scss";

import CloseIcon from "@mui/icons-material/Close";
import { Drawer } from "@mui/material";
import ButtonBase from "components/shared/ButtonBase";
import EmptyState from "components/shared/EmptyState";
import LastElementTable from "components/shared/LastElementTable";
import type { LastElementTableColumns } from "components/shared/LastElementTable/type";
import StyledButton from "components/shared/StyledButton";
import UserAvatar from "components/shared/UserAvatar";
import { getIntegrationAuthorName } from "helpers/integrationHelpers";
import { formatLocaleDateString } from "helpers/utils";
import { useTranslation } from "react-i18next";
import type { IIntegrations } from "store/integrationsStore";
import type { IUser } from "types";

import type { TDetailsDrawer } from "../types";

interface IDetailsDrawer {
    data: TDetailsDrawer;
    onClose: () => void;
    users: IUser[];
}
const DetailsDrawer = ({ data, onClose, users }: IDetailsDrawer) => {
    const [t] = useTranslation();

    const integrationsColumns: LastElementTableColumns[] = [
        {
            id: "connectedBy",
            label: t("IntegrationsSettings.User"),
            align: "left",
            sort: true,
            format: (value: any, id, row: IIntegrations) => {
                const authorName = getIntegrationAuthorName(row, users, t);
                return (
                    <div className="connected-by-user">
                        <UserAvatar name={authorName} size="small" />
                        {authorName}
                    </div>
                );
            },
        },
        {
            id: "created",
            sort: true,
            align: "left",
            label: t("IntegrationsSettings.Added"),
            format: (value: any) => formatLocaleDateString({ date: value }),
        },
    ];

    return (
        <Drawer open={data.open} onClose={onClose} anchor="right">
            <div className="integration-details">
                <div className="integration-details-head">
                    <div className="integration-details-head-left">
                        <div className="integration-details-head-left-title">
                            {data.logo}
                            <div>
                                <h1>{data.integrationName}</h1>
                                <span>{t("IntegrationsSettings.ConnectionList")}</span>
                            </div>
                        </div>
                    </div>
                    <div className="integration-details-head-right">
                        <ButtonBase
                            variant="text"
                            styles={{ border: "none", width: "unset", height: "1.9rem" }}
                            onClick={onClose}
                        >
                            <CloseIcon sx={{ color: "black" }} className="term-details-close" />
                        </ButtonBase>
                    </div>
                </div>
                <div className="integration-details-body">
                    <LastElementTable
                        columns={integrationsColumns}
                        data={data.integrations}
                        bottomFooterContent={<></>}
                    />
                    {!data.integrations.length && <EmptyState type="integrations" />}
                </div>
            </div>
        </Drawer>
    );
};

export default DetailsDrawer;
